// src/components/WhyChooseUs/WhyChooseUs.js

import React from 'react';
import { 
  FaFlask, 
  FaShieldAlt, 
  FaClock, 
  FaHome, 
  FaUserMd, 
  FaBrain,
  FaCheckCircle,
  FaHeartbeat
} from 'react-icons/fa';

export default function WhyChooseUs() {
  const features = [
    {
      icon: FaFlask,
      title: "Labs You Actually Get to Choose",
      description: "Select your preferred diagnostic lab — anytime, anywhere. No arbitrary assignments, no guesswork. You're in charge."
    },
    {
      icon: FaShieldAlt,
      title: "Only the Trusted Ones",
      description: "Every partner lab is verified and NABL-accredited. Your reports are as reliable as they are readable."
    },
    {
      icon: FaClock,
      title: "Reports Delivered on Time",
      description: "No chasing, no delays. Your digital reports are ready when you need them."
    },
    {
      icon: FaHome,
      title: "Sample Collection, Your Way",
      description: "No queues, no commute. Our professionals come to you, at your doorstep, exactly when it suits you."
    },
    {
      icon: FaUserMd,
      title: "DMLT-Certified Phlebotomists",
      description: "Our trained professionals arrive fully equipped — including proper cold-chain storage — for a smooth, accurate sample collection experience."
    },
    {
      icon: FaBrain,
      title: "Smart AI Reports — Because Guesswork Isn't an Option",
      description: "Get intelligent insights with AI-powered reports that help you understand your health better."
    }
  ];

  return (
    <div className="py-16 px-4 md:px-8 bg-gradient-to-r from-red-600 to-red-700 mt-3">
      <div className="max-w-6xl mx-auto">
        
        {/* ===== HEADER - White Text ===== */}
        <div className="text-center mb-12">
          {/* Badge - Light */}
          <div className="inline-flex items-center gap-2 bg-white/20 text-white px-4 py-1.5 rounded-full shadow-md mb-4">
            <FaHeartbeat size={12} className="text-yellow-400" />
            <span className="text-xs font-bold tracking-wider uppercase">Why Choose Us</span>
            <FaHeartbeat size={12} className="text-yellow-400" />
          </div>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white">
            Why Choose <span className="text-yellow-400">MedrphaLabs?</span>
          </h2>
          
          <p className="text-white/80 text-sm mt-3 max-w-2xl mx-auto">
            We're redefining healthcare with transparency, trust, and technology at every step
          </p>
        </div>

        {/* ===== FEATURES - Simple List ===== */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={index} className="flex gap-4 items-start p-4 rounded-xl hover:bg-white/10 transition-all duration-300">
                {/* Icon - White Circle */}
                <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0 mt-1">
                  <Icon size={22} className="text-white" />
                </div>
                
                <div>
                  <h3 className="text-lg font-bold text-white mb-1">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-white/80 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* ===== BOTTOM STATS - White Background ===== */}
        {/* <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
          <div className="text-center">
            <p className="text-2xl font-bold text-white">10L+</p>
            <p className="text-sm text-white/70">Trusted Customers</p>
          </div>
          <div className="text-center border-t sm:border-t-0 sm:border-l border-white/20 py-2 sm:py-0">
            <p className="text-2xl font-bold text-white">99.9%</p>
            <p className="text-sm text-white/70">Satisfaction Rate</p>
          </div>
          <div className="text-center border-t sm:border-t-0 sm:border-l border-white/20 py-2 sm:py-0">
            <p className="text-2xl font-bold text-white">500+</p>
            <p className="text-sm text-white/70">Partner Labs</p>
          </div>
        </div> */}

        {/* ===== TRUST BADGES - White Text ===== */}
        <div className="mt-6 flex flex-wrap justify-center items-center gap-3 text-white/80">
          <div className="flex items-center gap-1.5 text-xs">
            <FaCheckCircle size={12} className="text-green-400" />
            <span>NABL Accredited</span>
          </div>
          <span className="text-white/30">|</span>
          <div className="flex items-center gap-1.5 text-xs">
            <FaCheckCircle size={12} className="text-green-400" />
            <span>ISO Certified</span>
          </div>
          <span className="text-white/30">|</span>
          <div className="flex items-center gap-1.5 text-xs">
            <FaCheckCircle size={12} className="text-green-400" />
            <span>DMLT Phlebotomists</span>
          </div>
          <span className="text-white/30">|</span>
          <div className="flex items-center gap-1.5 text-xs">
            <FaCheckCircle size={12} className="text-green-400" />
            <span>AI-Powered Reports</span>
          </div>
          <span className="text-white/30">|</span>
          <div className="flex items-center gap-1.5 text-xs">
            <FaCheckCircle size={12} className="text-green-400" />
            <span>Free Home Collection</span>
          </div>
        </div>
      </div>
    </div>
  );
}